import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import Paper from '~/components/Paper';
import GridItem from '~/components/GridItem';
import DependentsList from '../components/DependentsList';

function Dependents({ user }) {
  const { t } = useTranslation();
  return (
    <Paper
      Icon={AssignmentIndIcon}
      iconColor="purple"
      title={t('person.extras.dependents')}
    >
      <Grid container>
        <GridItem xs={12}>{user && <DependentsList user={user} />}</GridItem>
      </Grid>
    </Paper>
  );
}

Dependents.propTypes = {
  user: PropTypes.object,
};

export default React.memo(Dependents);
